(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabbed-features"] && !Shopify.designMode) return;
  try {
    

(function () {

  function activateFeature(root, blockId) {

    if (!root) return;

    var buttons = root.querySelectorAll(
      '[data-tabbed-feature-button]'
    );

    var panels = root.querySelectorAll(
      '[data-tabbed-feature-panel]'
    );

    buttons.forEach(function (button) {

      var isActive =
        button.dataset.blockId === blockId;

      button.classList.toggle(
        'is-active',
        isActive
      );

      button.setAttribute(
        'aria-selected',
        isActive ? 'true' : 'false'
      );

      if (isActive) {

        button.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });

      }

    });

    panels.forEach(function (panel) {

      var isActive =
        panel.dataset.blockId === blockId;

      panel.classList.toggle(
        'is-active',
        isActive
      );

      panel.hidden = !isActive;

    });

  }


  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '[data-tabbed-feature-button]'
        );

      if (!button) return;

      var root =
        button.closest(
          '[data-tabbed-features]'
        );

      if (!root) return;

      activateFeature(
        root,
        button.dataset.blockId
      );

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var block =
        event.target.closest(
          '[data-tabbed-feature-panel]'
        );

      if (!block) return;

      var root =
        block.closest(
          '[data-tabbed-features]'
        );

      if (!root) return;

      activateFeature(
        root,
        block.dataset.blockId
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
